var a={holyContainer:"layout-default-style-module_holyContainer__RXxp-"};export{a as default};
//# sourceMappingURL=layout-default.style.module.scss.js.map
